<script setup lang="ts">
import SurveyBuilt from "@/survey/components/SurveyBuilt.vue";
import {useRoute} from "vue-router";

const route = useRoute();
</script>

<template>
  <SurveyBuilt v-if="route.params.instanceId" :instance-id="Number(route.params.instanceId)" />
</template>
